import type { DsdEditorSumValidationCell } from "@/utils/dsd-editor/sum-validation";
import { DsdReviewSumValidationDetail } from "./sum-validation-detail";
import { DsdReviewGuideCard } from "../guide-card";
import { DsdReviewNoSelectionBox } from "../panel/no-selection-box";
import { DsdReviewSelectedCellCard } from "../panel/selected-cell-card";

/** 합계 검증 패널 — 셀을 고르기 전엔 안내, 고르면 상세 (합계 반영은 아직 없음) */
export const DsdReviewSumValidationPanel = ({
  count,
  selected,
  axisLabel,
  mismatchCells,
  onScrollToCell,
  onPrevious,
  onNext,
}: {
  count: number;
  selected: DsdEditorSumValidationCell | null;
  /** 선택 셀의 "행 | 열" 표기. 백엔드가 표기 경로를 붙이지 않은 문서면 "" */
  axisLabel: string;
  /** 이전/다음이 도는 불일치 셀 */
  mismatchCells: DsdEditorSumValidationCell[];
  onScrollToCell: () => void;
  onPrevious: () => void;
  onNext: () => void;
}) => (
  <div className="flex h-full flex-col gap-4 overflow-y-auto overscroll-contain p-4">
    <DsdReviewGuideCard
      mode="sum-validation"
      count={count}
      variant="embedded"
      collapsed={!!selected}
    />
    <div className="-mx-4 border-b border-line-normal" />
    {selected ? (
      <DsdReviewSumValidationDetail
        summary={
          <DsdReviewSelectedCellCard
            sectionName={selected.sectionName}
            axisLabel={axisLabel}
            value={selected.value}
            onScrollToCell={onScrollToCell}
          />
        }
        cell={selected}
        cells={mismatchCells}
        onPrevious={onPrevious}
        onNext={onNext}
      />
    ) : (
      <DsdReviewNoSelectionBox />
    )}
  </div>
);
